if (typeof loadeMoreSlider_G === "undefined") {
  globalThis.loadeMoreSlider_G = null;
}

if (typeof globalThis.prepareProductCardDeferredSlides !== "function") {
  globalThis.prepareProductCardDeferredSlides = (slider) => {
    if (slider.dataset.deferredSlidesReady === "true") return;

    const deferredSlides = slider.querySelector(
      ".product-card-deferred-slides"
    );
    if (!deferredSlides) return;

    slider.dataset.deferredSlidesReady = "true";

    const hydrateDeferredSlides = () => {
      if (!deferredSlides.isConnected) return;

      deferredSlides.replaceWith(deferredSlides.content.cloneNode(true));
      const productSlider = slider.swiper;
      productSlider?.update();
      productSlider?.pagination?.render();
      productSlider?.pagination?.update();
    };

    const finePointer = window.matchMedia(
      "(hover: hover) and (pointer: fine)"
    ).matches;

    if (finePointer) {
      ["pointerenter", "focusin"].forEach((eventName) => {
        slider.addEventListener(eventName, hydrateDeferredSlides, {
          once: true,
          passive: true,
          capture: true,
        });
      });
    }
  };
}

(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll(".product-card-js");
    const dir = document.querySelector("html").getAttribute("dir");

    let nextEl = ".product-button-group .swiper-button-next";
    let prevEl = ".product-button-group .swiper-button-prev";
    if (dir === "rtl") {
      [nextEl, prevEl] = [prevEl, nextEl];
    }
    sliders.forEach((slider, index) => {
      globalThis.prepareProductCardDeferredSlides(slider);
      if (slider?.swiper) return;

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const speed = slideCount > 30 ? 0 : 800;

      const productSlider = new Swiper(slider, {
        speed: speed,
        pagination: {
          el: ".product-pagination .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        allowTouchMove: true,
        990: {
          allowTouchMove: false,
        },
      });
    });
  };

  initSlider();
  loadeMoreSlider_G = initSlider;

  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });
})();
